module.exports = __webpack_public_path__ + "img/246.33300b62.png";